module.exports = __webpack_public_path__ + "img/ennetix-individual-network-elements-page4.605f02ec.png";